var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 21.4299C22.223 21.4299 23.6199 20.0331 23.6199 18.3099C23.6199 16.5868 22.223 15.1899 20.4999 15.1899C18.7768 15.1899 17.3799 16.5868 17.3799 18.3099C17.3799 20.0331 18.7768 21.4299 20.4999 21.4299Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1202 16.49C14.0902 7.83 26.9202 7.84 28.8802 16.5C30.0302 21.58 26.8702 25.88 24.1002 28.54C22.0902 30.48 18.9102 30.48 16.8902 28.54C14.1302 25.88 10.9702 21.57 12.1202 16.49Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.970ac36c6c727e709103806f2aa36cc8.svg";
export { ForwardRef as ReactComponent };